import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import "../styles/hero.css";

export default function Hero() {
  const { isAuthenticated } = useAuth();

  return (
    <main className="hero">
      <div className="hero__tracks" aria-hidden="true" />
      <div className="hero__steam" aria-hidden="true" />
      <div className="hero__content">
        <p className="hero__brand">Freight Train of Justice</p>
        <h1 className="hero__title">THE FREIGHT TRAIN TO HAPPY CLIENTS</h1>
        <p className="hero__support">
          The operator platform for law firms that turn inbound leads into retained
          clients — fast follow-up, clear attribution, no chaos.
        </p>
        <div className="hero__actions">
          <Link
            className="btn btn--primary"
            to={isAuthenticated ? "/leads" : "/signin"}
          >
            {isAuthenticated ? "Open inbox" : "Sign in"}
          </Link>
        </div>
      </div>
    </main>
  );
}
